import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AuthHeaderService } from "app/shared/auth-header.service";
import { environment } from "environments/environment";
import { BehaviorSubject, Observable } from "rxjs";
import { map, retry, switchMap, tap } from "rxjs/operators";
import { MiscService } from "app/shared/misc.service";
import { DeveloperService } from "app/modules/settings/developer-page/developer.service";
@Injectable({
  providedIn: "root",
})
export class MerchantTransactionsService {
  constructor(
    private http: HttpClient,
    private authHeaderService: AuthHeaderService,
    private miscService: MiscService,
    private developerService: DeveloperService,
  ) {}

  private buildUTCRange(
    startDate: string | undefined,
    endDate: string | undefined,
  ): { startDate: string; endDate: string } {
    return {
      startDate: startDate
        ? new Date(`${startDate}T00:00:00`).toISOString()
        : "",
      endDate: endDate ? new Date(`${endDate}T23:59:59`).toISOString() : "",
    };
  }
  private channelSource = new BehaviorSubject<string>("");
  channel$ = this.channelSource.asObservable();
  selectedChannel$ = new BehaviorSubject<string>("");
  fetchTransactions(
    merchant_id: string,
    page_num: number,
    limit: number,
    channel_id?: string,
    product_id?: string,
    start_date?: string,
    end_date?: string,
    trans_type?: string,
    provider?: string,
    search_query?: string,
    sourceProvider?: string,
    filter_type?: string,
    gift_aid_process?: boolean | string | null,
    settledTransaction?: string,
    status?: string,
  ): Observable<any> {
    const { startDate, endDate } = this.buildUTCRange(start_date, end_date);
    let url = `${environment.API_URL2}/transactions-service/merchant/transactions/${merchant_id}?page_num=${page_num}&limit=${limit}`;

    if (channel_id) {
      url += `&channel_id=${channel_id}`;
    }
    if (trans_type) {
      url += `&trans_type=${trans_type}`;
    }
    if (provider) {
      url += `&des_sort_route_no=${provider}`;
    }
    if (product_id) {
      url += `&product_id=${product_id}`;
    }

    if (sourceProvider) {
      url += `&src_sort_route_no=${sourceProvider}`;
    }

    if (startDate) {
      url += `&start=${startDate}`;
    }

    if (endDate) {
      url += `&end=${endDate}`;
    }

    if (search_query) {
      url += `&search=${search_query}`;
    }
    if (filter_type === "GIFTAID") {
      if (gift_aid_process == "true") {
        url += `&gift_aid=true&gift_aid_process=true`;
      } else if (gift_aid_process == "false") {
        url += `&gift_aid=true&gift_aid_process=false`;
      } else if (gift_aid_process == null) {
        url += `&gift_aid=true`;
      }
    } else if (
      filter_type &&
      filter_type.toLowerCase() !== "all"
    ) {
      url += `&filter_type=${filter_type}`;
    }
    if (settledTransaction) {
      url += `&settled=${settledTransaction}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    return this.http.get(`${url}`).pipe(retry(1));
  }
  useCategoryProviderFilters = false;

  setChannel(channel: string) {
    this.channelSource.next(channel);
  }

  resetChannel() {
    this.useCategoryProviderFilters = false;
    this.selectedChannel$.next("");
  }

  downloadTransactions(
    merchant_id: string,
    channel_id?: string,
    product_id?: string,
    start_date?: string,
    end_date?: string,
    search_query?: string,
    filter_type?: string,

    // trans_type?: string,
    gift_aid_process?: boolean | string | null,
    settledTransaction?: string,
    trans_type?: string,
    des_provider?: string,
    src_provider?: string,
    provider?: string,
    metadataKeys: string[] = [],
    format: 'xlsx' | 'pdf' = 'xlsx',
  ): Observable<any> {
    const { startDate, endDate } = this.buildUTCRange(start_date, end_date);
    let params = new HttpParams();
    params = params.append("format", format);
    params = params.append("status", "success");
    
    // params = params.append('page', '0');
    // params = params.append('limit', '1000');
    if (channel_id) params = params.append("channel_id", channel_id);
    if (product_id) params = params.append("product_id", product_id);
    if (startDate) params = params.append("start", startDate);
    if (endDate) params = params.append("end", endDate);

    if (search_query) params = params.append("search", search_query);
    if (settledTransaction)
      params = params.append("settled", settledTransaction);
    if (trans_type) {
      params = params.append("trans_type", trans_type);
    }
    if (des_provider) {
      params = params.append("des_sort_route_no", des_provider);
    }
    if (src_provider) {
      params = params.append("src_sort_route_no", src_provider);
    }
    // if(trans_type)
    //   params = params.append('trans_type', trans_type)
    if (filter_type?.toUpperCase() === "GIFTAID") {
      if (gift_aid_process == "true") {
        params = params.append("gift_aid", true);
        params = params.append("gift_aid_process", true);
      } else if (gift_aid_process == "false") {
        params = params.append("gift_aid", true);
        params = params.append("gift_aid_process", false);
      } else if (gift_aid_process == null) {
        params = params.append("gift_aid", true);
      }
    } else if (filter_type && filter_type.toLowerCase() !== "all") {
      params = params.append("filter_type", filter_type);
    }
    if (metadataKeys.length > 0) {
      params = params.append("meta_export", metadataKeys.join(","));
    }
    // const headers = new HttpHeaders({
    //   "Content-Type":
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    // });
    return this.http
      .get(
        `${environment.API_URL2}/transactions-service/merchant/transactions/${merchant_id}`,
        { params, responseType: "blob" },
      )
      .pipe(retry(1));
  }

  getClearedUnclearedBalance = (merchantId) =>
    this.http
      .get(
        `${environment.API_URL2}/transactions-service/merchant/accounts/${merchantId}/balance`,
      )
      .pipe(retry(1));

  outstandingTransactions(
    merchant_id: string,
    page_num: number,
    limit: number,
  ): Observable<any> {
    let url = `${environment.API_URL2}/transactions-service/merchant/outstanding-transactions/${merchant_id}?page=${page_num}&limit=${limit}`;
    return this.http.get(`${url}`).pipe(retry(1));
  }

  resolvePendingTransaction(id: string): Observable<any> {
    let url = `${environment.API_URL2}/transactions-service/merchant/outstanding-transactions/resolve/${id}`;
    return this.http.get(`${url}`).pipe(retry(1));
  }

  refundPendingTransaction(id: string): Observable<any> {
    let url = `${environment.API_URL2}/transactions-service/merchant/outstanding-transactions/refund/${id}`;
    return this.http.get(`${url}`).pipe(retry(1));
  }

  deletePendingTransaction(id: string): Observable<any> {
    let url = `${environment.API_URL2}/transactions-service/merchant/outstanding-transactions/${id}`;
    return this.http.delete(`${url}`).pipe(retry(1));
  }

  fetchMerchantTransactionFilters = (merchant_id): Observable<any> => {
    return this.http.get(
      `${environment.API_URL2}/transactions-service/merchant/transaction-filters/${merchant_id}`,
    );
  };

  fetchInvestmentAnalytics = (
    merchant_id: string,
    user_id?: string,
  ): Observable<any> => {
    let url = `${environment.API_URL2}/xas/v1/pots/investment/analytics/${merchant_id}`;
    if (user_id) {
      url = url + `?user_id=${user_id}`;
    }
    return this.http.get(url);
  };

  fetchInvestments = (
    page_num: number,
    limit: number,
    merchant_id: string,
    filter_key: string = "",
    status?: string,
    search?: string,
    start_date?: string,
    end_date?: string,
    user_id?: string,
  ): Observable<any> => {
    const { startDate, endDate } = this.buildUTCRange(start_date, end_date);
    let url = "";
    if (user_id) {
      url = `${environment.API_URL2}/xas/v1/pots/user/investment/pots/${merchant_id}/${user_id}?page=${page_num}&limit=${limit}`;
    } else {
      url = `${environment.API_URL2}/xas/v1/pots/merchant/investment/pots/${merchant_id}?page=${page_num}&limit=${limit}`;
    }
    if (status) {
      url = url + `&status=${status}`;
    }
    if (filter_key) {
      url = url + `&filter=${filter_key}`;
    }
    if (search) {
      url = url + `&search=${search}`;
    }
    if (startDate) {
      url = url + `&start_date=${startDate}`;
    }
    if (endDate) {
      url = url + `&end_date=${endDate}`;
    }
    return this.http.get(url);
  };

  fetchUserDetails = (
    page_num: number,
    limit: number,
    merchant_id: string,
    user_id: string,
  ): Observable<any> => {
    return this.http.get(
      `${environment.API_URL2}/xas/v1/pots/user/investment/history/${merchant_id}/${user_id}?page=${page_num}&limit=${limit}`,
    );
  };

  fetchInvestmentHistory = (merchant_id: string): Observable<any> => {
    return this.http.get(
      `${environment.API_URL2}/xas/v1/pots/merchant/investment/history/${merchant_id}`,
    );
  };

  getMerchantPaymentChannels = (): Observable<any> =>
    this.http.get(
      `${environment.API_URL2}/transactions-service/merchant/channels/overview/${this.miscService.getMerchantDetails().merchant_id}`,
    );

  refundTransaction = (payload, country_code, transaction_id) => {
    return this.http.post(
      `${environment.API_URL2}/xas/v1/merchant/transactions/refund/${country_code}/${transaction_id}`,
      payload,
    );
  };
  updateToGiftAid = (payload, country_code, transaction_id) => {
    return this.http.put(
      `${environment.API_URL2}/transactions-service/transactions/gift-aid/${country_code}/${transaction_id}`,
      payload,
    );
  };
  processGiftAidTransactions = (payload, country_code) => {
    return this.http.put(
      `${environment.API_URL2}/transactions-service/transactions/gift-aid-process/${country_code}`,
      payload,
    );
  };

  getExchangeRate = (type, recipeint, srcCountry, desCountry) =>
    this.http.get(
      `${environment.API_URL2}/xas/v1/fees/transfer/${type}/${recipeint}/${srcCountry}/${desCountry}`,
    );

  calculateExchangeRate = (payload: any, providerCode?: string): Observable<any> => {
    if (providerCode) {
      const params = new HttpParams().set('to_provider_code', providerCode);
      return this.http.post(`${environment.API_URL2}/xas/v1/exchange/new-calculate`, payload, { params });
    }
    return this.http.post(`${environment.API_URL2}/xas/v1/exchange/new-calculate`, payload);
  }

  calculateEZremitExchangeRate = (payload: any, destinationCountryCode: string, partnerIdentifier: string): Observable<any> => {
    const params = new HttpParams()
      .set('to_provider_code', 'ezremit')
      .set('destination_country_code', destinationCountryCode)
      .set('partner_identifier', partnerIdentifier);
    return this.http.post(`${environment.API_URL2}/xas/v1/exchange/new-calculate`, payload, { params });
  }

  fetchMomoProviders = (countryCode: string): Observable<any> =>
    this.http.get(
      `${environment.API_URL2}/xas/v1/merchant/accounts/momo-mnos/${countryCode}`,
    );

  validateMomoAccount = (
    countryCode,
    accountNo,
    bankCode,
    type,
  ): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set("X-Auth-Signature", xAuthHeader)
      .set("X-APP-ID", `${environment.X_APP_ID}`)
      .set("X-ISSUER-ID", `${environment.X_ISSUER_ID}`);

    return this.http.get(
      `${environment.API_URL2}/xas/v1/merchant/accounts/validate/${countryCode}/${accountNo}/${bankCode}/${type}`,
      { headers },
    );
  };

  fetchFailedTransactions(
    merchant_id: string,
    page: number,
    limit: number,
    status: string,
    type: string,
    startDate?: string,
    endDate?: string,
    searchQuery?: string,
    medium?: string,
  ): Observable<any> {
    const { startDate: utcStart, endDate: utcEnd } = this.buildUTCRange(
      startDate,
      endDate,
    );

    let params = new HttpParams()
      .set("page", page)
      .set("limit", limit)
      .set("merchant_id", merchant_id)
      .set("status", status)
      .set("type", type);

    if (utcStart) {
      params = params.set("startDate", utcStart);
    }

    if (utcEnd) {
      params = params.set("endDate", utcEnd);
    }

    if (medium && medium !== "momo") {
      params = params.set("medium", medium);
    }

    if (searchQuery) {
      params = params.set("search", searchQuery);
    }

    return this.http.get(`${environment.TRANSACTION_URL}/momo/logs`, {
      params,
    });
  }

  exportFailedTransactions(
    merchant_id: string,
    status: string,
    type: string,
    startDate?: string,
    endDate?: string,
    search?: string,
    medium?: string,
  ) {
    const { startDate: utcStart, endDate: utcEnd } = this.buildUTCRange(
      startDate,
      endDate,
    );
    let params = new HttpParams()
      .set("merchant_id", merchant_id)
      .set("status", status)
      .set("type", type);

    if (utcStart) params = params.set("startDate", utcStart);
    if (utcEnd) params = params.set("endDate", utcEnd);
    if (search) params = params.set("search", search);
    if (medium) params = params.set("medium", medium);
    if (status) params = params.set("status", status);

    return this.http.get(`${environment.TRANSACTION_URL}/momo/logs/export`, {
      params,
      responseType: "blob",
    });
  }

  fetchReversedTransactions (
    merchant_id: string,
    start: string,
    end: string,
    page_num: string | number,
    limit: string | number,
    search?: string,
    product_id?: string,
    channel_id?: string,
    trans_type?: string,
    src_account?: string,
    des_account?: string,
    src_sort_route_no?: string,
    des_sort_route_no?: string,
    gift_aid?: string,
    gift_aid_process?: string,
    format?: string,
    filter_type?: string,
    filter_date_type?: string,
    settled?: string,
    status?: string,
    meta_export?: string,
  ) :Observable<any> {
    let params = this.buildReversedTransactionParams(start, end, search)
      .set('page_num', page_num)
      .set('limit', limit);

    if (product_id) params = params.set('product_id', product_id);
    if (channel_id) params = params.set('channel_id', channel_id);
    if (trans_type) params = params.set('trans_type', trans_type);
    if (src_account) params = params.set('src_account', src_account);
    if (des_account) params = params.set('des_account', des_account);
    if (src_sort_route_no) params = params.set('src_sort_route_no', src_sort_route_no);
    if (des_sort_route_no) params = params.set('des_sort_route_no', des_sort_route_no);
    if (gift_aid) params = params.set('gift_aid', gift_aid);
    if (gift_aid_process) params = params.set('gift_aid_process', gift_aid_process);
    if (format) params = params.set('format', format);
    if (filter_type) params = params.set('filter_type', filter_type);
    if (filter_date_type) params = params.set('filter_date_type', filter_date_type);
    if (settled) params = params.set('settled', settled);
    if (status) params = params.set('status', status);
    if (meta_export) params = params.set('meta_export', meta_export);

    return this.http.get(`${environment.TRANSACTION_URL}/merchant/transactions/reversals/${merchant_id}`, {params});
  }

  private buildReversedTransactionParams(start: string, end: string, search?: string): HttpParams {
    const { startDate, endDate } = this.buildUTCRange(start, end);
    let params = new HttpParams();
    if (startDate) params = params.set('start', startDate);
    if (endDate) params = params.set('end', endDate);
    if (search?.trim()) params = params.set('search', search.trim());
    return params;
  }

  downloadReversedTransactions(
    merchant_id: string,
    start: string,
    end: string,
    search: string,
    metadataKeys: string[] = [],
    filter_type?: string,
  ): Observable<Blob> {
    let params = this.buildReversedTransactionParams(start, end, search)
      .set('format', 'xlsx');
    if (filter_type) params = params.set('filter_type', filter_type);
    if (metadataKeys.length) params = params.set('meta_export', metadataKeys.join(','));
    return this.http.get(
      `${environment.TRANSACTION_URL}/merchant/transactions/reversals/${merchant_id}`,
      { params, responseType: 'blob' },
    );
  }

  private getPapssHeaders = (): Observable<HttpHeaders> =>
    this.developerService
      .fetchApiKey()
      .pipe(
        map((res) =>
          new HttpHeaders()
            .set("x-api-key", res.data.api_key)
            .set(
              "x-merchant-id",
              this.miscService.getMerchantDetails().merchant_id,
            ),
        ),
      );

  getPapssCountries = (): Observable<any> =>
    this.getPapssHeaders().pipe(
      switchMap((headers) =>
        this.http.get(`${environment.API_URL3}/external/papss/countries`, {
          headers,
        }),
      ),
    );

  getPapssParticipants = (countryCode: string): Observable<any> =>
    this.getPapssHeaders().pipe(
      switchMap((headers) =>
        this.http.get(`${environment.API_URL3}/external/papss/${countryCode}`, {
          headers,
        }),
      ),
    );

  validatePapssAccount = (
    countryCode: string,
    accountNo: string,
    bankCode: string,
  ): Observable<any> =>
    this.getPapssHeaders().pipe(
      switchMap((headers) =>
        this.http.get(
          `${environment.API_URL3}/external/papss/validate/${countryCode}/${accountNo}/${bankCode}`,
          { headers },
        ),
      ),
    );

  getPapssExchangeRates = (
    srcCountry: string,
    desCountry: string,
    orgNo: string,
    amount?: number,
  ): Observable<any> => {
    let params = new HttpParams()
      .set("src_country", srcCountry)
      .set("des_country", desCountry)
      .set("org_no", orgNo);
    if (amount !== undefined) {
      params = params.set("amount", amount);
    }
    return this.getPapssHeaders().pipe(
      switchMap((headers) =>
        this.http.get(`${environment.API_URL3}/external/papss/exchange-rates`, {
          headers,
          params,
        }),
      ),
    );
  };

  getPapssPaymentStatus = (reference: string): Observable<any> =>
    this.getPapssHeaders().pipe(
      switchMap((headers) =>
        this.http.get(
          `${environment.API_URL3}/external/payment/status/${reference}`,
          { headers },
        ),
      ),
    );

  getPapssTransferFee = (
    srcCountry: string,
    desCountry: string,
    orgNo: string,
    amount: number | string,
    isPapss: boolean,
  ): Observable<any> => {
    let params = new HttpParams()
      .set('org_no', orgNo)
      .set('is_papss', isPapss.toString())
      .set('amount', amount.toString());
    return this.http.get(`${environment.API_URL2}/xas/v1/fees/transfer/transfer/bank/${srcCountry}/${desCountry}`, { params });
  }

  queryTransactionStatus = (countryCode: string, reference: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);


    return this.http.get(`${environment.API_URL2}/xas/v1/external/tsq/unified/${countryCode}/${reference}`, { headers });
  }

}
